import { DayScheduleRange } from '../models/new-area-draft.types';

/**
 * Etiqueta 12 h que representa fin de día API `24:00` en UI (time field no admite 24:00).
 * Si el usuario cambia "Hasta", se limpia `toTimeEndOfDay` en el draft.
 */
export const AVAILABILITY_END_OF_DAY_END_SENTINEL_LABEL = '11:59 PM';

const HH_MM_24_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;

/**
 * Convierte `HH:mm` del GET de reglas a etiqueta 12 h para `app-time-input-field`.
 * Cadenas no reconocidas se devuelven tal cual (p. ej. ya en 12 h).
 */
export function availabilityApiTimeTo12hLabel(raw: string): string {
  const v = String(raw ?? '').trim();
  if (v === '24:00') return '';
  if (!HH_MM_24_REGEX.test(v)) return v;
  const [hStr, mStr] = v.split(':');
  const h24 = Number(hStr);
  const mm = Number(mStr);
  const meridiem = h24 < 12 ? 'AM' : 'PM';
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${String(h12).padStart(2, '0')}:${String(mm).padStart(2, '0')} ${meridiem}`;
}

/**
 * Convierte etiqueta de hora del formulario a `HH:mm` 24 h para el PATCH.
 * Si ya viene en 24 h (`09:00`), se devuelve sin cambios.
 */
export function reservationScheduleTimeLabelToApi24h(raw: string): string {
  const v = String(raw ?? '').trim();
  const match12 = v.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (match12) {
    let hh = Number(match12[1]);
    const mm = Number(match12[2]);
    const meridiem = match12[3].toUpperCase();
    if (meridiem === 'AM') {
      hh = hh === 12 ? 0 : hh;
    } else {
      hh = hh === 12 ? 12 : hh + 12;
    }
    return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
  }
  return v;
}

export function dayScheduleRangeToApiSlot(r: DayScheduleRange): { start: string; end: string } | null {
  const start = reservationScheduleTimeLabelToApi24h(String(r.fromTimeLabel ?? '').trim());
  const end = r.toTimeEndOfDay ? '24:00' : reservationScheduleTimeLabelToApi24h(String(r.toTimeLabel ?? '').trim());
  if (!start || !end) return null;
  return { start, end };
}
